import CakeIcon from '@material-ui/icons/Cake';
export const GeboorteDatumIcon = CakeIcon;

